import React, { useState, useEffect, useContext } from "react";
import Pagination from "rc-pagination";

import "./transaction.scss";
import {
  FaCheckCircle,
  FaRegPlusSquare,
  FaRegMinusSquare,
  FaPlus,
  FaMinus,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import CreatableSelect from "react-select";

import "react-toastify/dist/ReactToastify.css";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
// import {
//   TransferToCard,
//   TransactionRecords,
//   date,
//   inventory,
//   Charg,
// } from "./transactions.js";
import { useParams } from "react-router-dom";
import { connection } from "../../../utils/apiConnection.ts";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
// import toast from "react-hot-toast";

// import { showSwalError, showSwalSuccess } from "../../utilities/swal";

const date = (TimeStamp) => {
  let options = { year: "numeric", month: "numeric", day: "numeric" };
  let date = new Date(parseInt(TimeStamp) * 1000);

  let FaDate = date.toLocaleDateString("fa-IR", options);
  FaDate.replace(/([۰-۹])/g, (token) =>
    String.fromCharCode(token.charCodeAt(0) - 1728)
  );
  return [date.getHours(), date.getMinutes(), FaDate, date];
};

function Transa({ info, key }) {
  const [dateValue, setDateValue] = useState("");

  useEffect(() => {
    setDateValue(date(info.mtm));
  }, []);

  return (
    <div
      className="d-flex flex-row px-3 my-3  mx-1 transaction-card shadow"
      style={{
        // border: "2px solid #A7A9D6",
        borderRadius: "10px",
        // width: "48%",
      }}
    >
      {/* <FaCheckCircle
        className="fs-3 me-2"
        style={{ color: "#303481", marginTop: "13px" }}
      /> */}
      <div className="d-flex flex-column  justify-content-around w-100">
        <div
          className="d-flex flex-column justify-content-between flex-wrap "
          style={{ height: "140px" }}
        >
          {/* wallets_transactions */}

          {info.type == 0 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>شارژ حساب</h5>
                </div>
                <div>{/* <h5>{addCommas(info.amount)}</h5> */}</div>
              </div>
            </div>
          ) : info.type == 1 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>خرید از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
            </div>
          ) : info.type == 2 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>به</h5>
                </div>
                <div>
                  <h5>{info.to_wallet_id}</h5>
                </div>
              </div>
            </div>
          ) : info.type == 3 ? (
            <div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>برداشت از حساب</h5>
                </div>
                <div>
                  <h5>{info.from_wallet_id}</h5>
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between flex-wrap my-3">
                <div>
                  <h5>انتقال به شماره کارت</h5>
                </div>
                <div>
                  <h5>{info.tparams}</h5>
                </div>
              </div>
            </div>
          ) : null}

          {/* 
            0=>شارژ
            1=>خرید
            2=>انتقال داخلی
            3=> برداشت
          */}
        </div>
        <div
          className="d-flex flex-row align-items-center py-2 justify-content-between  flex-wrap "
          style={{ height: "70px", borderTop: "2px solid darkblue" }}
        >
          <h5 className="d-flex justify-content-between w-100 flex-row-reverse">
            <span>{date(info.mtm)[2]}</span>
            <span>{`${date(info.mtm)[0]}:${date(info.mtm)[1]}`}</span>
            {/* <span className="ms-4 date-card">{dateValue[2]}</span>
            <span>{`${dateValue[0]}:${dateValue[1]}`}</span> */}
          </h5>
          <h5 className="date-card1">
            {addCommas(info.amount.toLocaleString())} ریال
          </h5>
        </div>
      </div>
    </div>
  );
}

//import Pagination from "rc-pagination";
export default function Transactions({ type, otherInfo }) {
  const [style, setstyle] = useState([true, false, false]);
  const [CostButton, setCostButton] = useState([false, false, false]);
  const [costInput, setcostInput] = useState("0");
  const [Input1, setInput1] = useState("");
  const [Input2, setInput2] = useState("");
  const [records, setRecords] = useState([]);
  const [update, setUpdate] = useState(true);
  const [current_inventor, setCurrent_inventor] = useState(0);
  const [Transactions, setTransactions] = useState([]);
  const [Transactions2, setTransactions2] = useState([]);
  const [Key, setKey] = useState(true);
  const [bank, setBank] = useState([]);
  const [selectNumber, setSelectNumber] = useState([]);
  const auth = useContext(WithAuthentication);
  const [currentPage, setCurrentPage] = useState(1);
  const [time, setTime] = useState("");
  const [chang, setChang] = useState(true);

  const { supplier_id } = useParams();

  // const auth = { userInfo: { id :2} };
  const InventoryUpdate = () => {
    setCurrent_inventor((perv) => perv.parseInt - +Input2.parseInt);
    console.log("current_inventor", current_inventor);
  };

  async function TransferToCard(CartNumber, price, muid) {
    console.log("secend step");
  }

  useEffect(() => {
    let Day = new Date();
    let date = new Date(parseInt(Day.getTime()));
    let FaDate = date.toLocaleDateString("fa-IR");
    setTime(FaDate.split("/"));
    if (type == 2) {
      if (otherInfo.bank_info) {
        JSON.parse(otherInfo.bank_info).map((item) => {
          if (item.checked) {
            setBank([
              ...bank,
              {
                value: item.accountNumber,
                label: item.nameBank + "-" + item.accountNumber,
              },
            ]);
          }
        });
      }
    }
  }, [otherInfo]);

  useEffect(() => {
    connection("api/Find_wallets_transactions", {
      // tbl_name: "left join,users,muid,id",
      conditions: `muid/=/${auth.userInfo.id}`,
      count: 10,
      page: 1,
    }).then((res) => {
      setTransactions(res);
    });

    // SELECT * FROM `wallets_transactions` WHERE EXISTS (SELECT * FROM wallets WHERE (wallets.id = wallets_transactions.from_wallet_id OR wallets.id = wallets_transactions.to_wallet_id) AND wallets.type = 2 AND wallets.uid = 53)

    // find(
    //   [],
    //   ""
    // );
    if (type != 1) {
      connection("api/Find_wallets_transactions", {
        // tbl_name: "left join,users,muid,id",
        conditions: `/exists/(SELECT * FROM wallets WHERE (wallets.id = wallets_transactions.from_wallet_id OR wallets.id = wallets_transactions.to_wallet_id) AND wallets.type = 2 AND wallets.uid = ${supplier_id} AND wallets_transactions.type = 3)`,
        // type/=/3@@transaction_type/=/2@@muid/=/${supplier_id}
        // count: 10,
        //page: 1,
      }).then((res) => {
        setTransactions2(res);
      });
    }

    connection("api/Find_wallets", {
      conditions:
        type === 0 ? `uid/=/${auth.userInfo.id}` : `uid/=/${supplier_id}`,
    }).then((res) => {
      res[0] && setCurrent_inventor(res[0]["current_inventory"]);
    });

    // let array = await TransactionRecords((auth.userInfo.id));
    // setRecords(array);
    // let data = await inventory((auth.userInfo.id));
    // setCurrent_inventor(data);
  }, [update]);

  const click = (TAB) => {
    setstyle(
      style.map((value, index) => {
        if (index == TAB) {
          return true;
        } else {
          return false;
        }
      })
    );
  };

  const clickCost = (TAB) => {
    setCostButton(
      CostButton.map((value, index) => {
        if (index == TAB) {
          return !value;
        } else {
          return false;
        }
      })
    );
  };

  function TransferTo(input1, input2) {
    if (input1 == "" && input2 == "") {
      toast.error("مبلغ و شماره کارت را وارد کنید!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      //  if (current_inventor) {
      //  } else {
      //  }
      connection("api/Find_wallets", {
        // conditions: `uid/=/${parseInt(auth.userInfo.id)}`,
        conditions:
          type === 0 ? `uid/=/${auth.userInfo.id}` : `uid/=/${supplier_id}`,
      }).then((fromWalletId) => {
        if (fromWalletId[0]["current_inventory"] <= 0) {
          toast.error("موجودی کافی نیست!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          connection("api/Find_wallets", {
            conditions: `uid/=/1`,
          }).then((toWalletId) => {
            let mtm = new Date();
            mtm = parseInt(mtm.getTime() / 1000);

            connection("api/Insert_wallets_transactions", {
              type: 3,
              transaction_type: 3,
              amount: input2,
              from_wallet_id: fromWalletId[0]["id"],
              to_wallet_id: toWalletId[0]["id"],
              factor_id: 0,
              mtm: mtm,
              tparams: input1,
              main_status: 2,
            }).then((res) => {
              if (res.status) {
                let result = res.result.id;

                // if (reverse) keyvalues.reverse = 1;
                connection("api/updatewalletsfortransfer", {
                  from_wallet_id: fromWalletId[0]["id"],
                  to_wallet_id: toWalletId[0]["id"],
                  amount: input2,
                }).then((res) => {
                  console.log(res.status == 1, "res");
                  if (res.status == 1) {
                    setUpdate(!update);
                    toast.success("درخواست ارسال شد", {
                      position: "top-center",
                      autoClose: 2000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  } else {
                    toast.error("مشکلی پیش آمده لطفا دوباره امتحان کنید!", {
                      position: "top-center",
                      autoClose: 2000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  }
                  return res.status == 1;
                });

                // return res2 ? result : false;
              } else {
                toast.error("مشکلی پیش آمده لطفا دوباره امتحان کنید!", {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }
            });
          });
        }
      });

      //  TransferToCard(
      //   input1,
      //   input2,
      //   // parseInt(auth.userInfo.id)
      //   2
      // ).then((res) => {
      //   console.log(res, "first step");

      // });
      // console.log(res, "first step");
      // if (false) {
      //   setUpdate(!update);
      //   toast.success("درخواست ارسال شد", {
      //     position: "top-center",
      //     autoClose: 2000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
      // }
    }
  }

  const Charg = (cost) => {
    if (cost == 0) {
      toast.error("مبلغ را وارد کنید!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      // let form = new FormData();
      // form.append("factor_id", -1);
      // form.append("pay_amount", `${cost}`);
      // form.append("callback", "customer-panel/transactions");
      // form.append("usertoken", Cookie.get("login_key"));

      connection("api/charge_wallet", {
        pay_amount: `${cost}`,
        callback: "/financial-department",
      }).then((data) => {
        if (data.state == 1) {
          window.location.href = `${data.data.url}`;
        } else {
          toast.error("مشکلی به وجود آمده لطفا دوباره امتحان کنید!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  };

  return (
    <div
      className="bg-white m-0 rounded-3 mx-auto Transactions d-flex flex-column  mt-5"
      // style={{ border: "1px solid gray" }}
      style={{ width: "100%" }}
    >
      <ul
        class="nav nav-tabs m-3  w-75  mx-auto "
        id="pills-tab"
        role="tablist"
        style={{ borderBottom: "2px solid #303481" }}
      >
        <li class="nav-item  " role="presentation">
          <a
            class="nav-link  btn buttonTAb"
            onClick={() => click(0)}
            data-style={style[0]}
            id="buttonTAb1"
            data-bs-toggle="tab"
            data-bs-target="#Tab1"
            type="button"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
            style={{ padding: "3px 11px" }}
          >
            تراکنش
          </a>
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link btn buttonTAb"
            onClick={() => click(1)}
            data-style={style[1]}
            id="buttonTAb2"
            data-bs-toggle="tab"
            data-bs-target="#Tab2"
            type="button"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            style={{ padding: "3px 11px" }}
          >
            سوابق تراکنش
          </a>
        </li>
        {/* {type != 0 && ( */}
        {type == 2 && (
          <li class="nav-item " role="presentation">
            <a
              class="nav-link btn buttonTAb"
              onClick={() => click(2)}
              data-style={style[2]}
              id="buttonTAb3"
              data-bs-toggle="tab"
              data-bs-target="#Tab3"
              type="button"
              role="tab"
              aria-controls=""
              aria-selected="false"
              style={{ padding: "3px 11px" }}
            >
              درخواست های برداشت
            </a>
          </li>
        )}
      </ul>

      <div class="tab-content  w-75 mx-auto " id="pills-tabContent">
        <div
          class="tab-pane fade show active div-Shadow"
          id="Tab1"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <div
            className="w-100 mx-auto pb-3 tabNumOne"
            style={{ borderBottom: "2px solid #303481" }}
          >
            <h4 className="text-right fw-bolder my-4">
              <strong>شارژ کیف پول</strong>
            </h4>
            <h5>موجودی فعلی: {addCommas(current_inventor)} تومان</h5>

            <div
              class="btn-group   d-flex flex-row justify-content-between flex-wrap w-75 mx-auto my-4 mb-2"
              role="group"
              aria-label="Basic checkbox toggle button group"
            >
              <button
                onClick={() => {
                  clickCost(0) || CostButton[0]
                    ? setcostInput(0)
                    : setcostInput(300000);
                }}
                className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow border-0 px-4"
                style={{
                  backgroundColor: CostButton[0] && "gray",
                  color: CostButton[0] && "white",
                }}
              >
                300,000 تومان
              </button>
              <button
                onClick={() => {
                  clickCost(1) || CostButton[1]
                    ? setcostInput(0)
                    : setcostInput(200000);
                }}
                className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow  border-0  px-4"
                style={{
                  backgroundColor: CostButton[1] && "gray",
                  color: CostButton[1] && "white",
                }}
              >
                200,000 تومان
              </button>
              <button
                id="btn5"
                onClick={() => {
                  clickCost(2) || CostButton[2]
                    ? setcostInput(0)
                    : setcostInput(50000);
                }}
                className="btn btn-outline-secondary m-2 rounded-pill cost-width shadow border-0  d-none  px-5"
                style={{
                  backgroundColor: CostButton[2] && "gray",
                  color: CostButton[2] && "white",
                }}
              >
                50,000 تومان
              </button>
            </div>
            <div
              class="btn-group  text-center d-flex flex-row justify-content-between flex-wrap mx-auto my-4 mt-0"
              role="group"
              aria-label="Basic checkbox toggle button group"
              style={{ width: "72%" }}
              id="div5"
            >
              <button
                onClick={() => {
                  clickCost(2) || CostButton[2]
                    ? setcostInput(0)
                    : setcostInput(50000);
                }}
                className="btn btn-outline-secondary rounded-pill cost-width shadow border-0 px-5 w-100"
                style={{
                  backgroundColor: CostButton[2] && "gray",
                  color: CostButton[2] && "white",
                }}
              >
                50,000 تومان
              </button>
            </div>

            <div
              className="text-center d-flex flex-row mx-auto my-3 position-relative"
              style={{ width: "222px", height: 34 }}
            >
              <button
                className="btn border-none shadow-none p-0 position-absolute"
                style={{ width: "fit-content", right: "11px" }}
                onClick={() =>
                  setcostInput(parseInt(costInput) + 10000) || clickCost(-1)
                }
              >
                <FaPlus style={{ width: "20px" }} className="fs-6 mt-2" />
              </button>
              <input
                // type="number"
                style={{ width: "222px", padding: "0px 28%" }}
                value={addCommas(costInput)}
                onChange={(e) => {
                  setcostInput(removeCommas(e.target.value)) || clickCost(-1);
                }}
                className={` mx-1 ${
                  costInput == "" ? "border-0" : "border"
                } rounded-pill shadow text-center`}
                placeholder="مبلغ های دیگر"
              ></input>
              <button
                className="btn border-none shadow-none p-0 position-absolute"
                style={{ width: "fit-content", left: "0px" }}
                onClick={() =>
                  costInput > 0
                    ? setcostInput(parseInt(costInput) - 10000) || clickCost(-1)
                    : null
                }
              >
                <FaMinus style={{ width: "20px" }} className="fs-6 mt-2" />
              </button>
            </div>
            <div className="text-end">
              <button
                type="button"
                className="btn text-white border-3 border-light but-width"
                style={{
                  backgroundColor: "green",
                  borderRadius: "10px",
                  padding: "5px 50px",
                  borderRadius: "15px",
                }}
                onClick={() => Charg(costInput)}
              >
                پرداخت
              </button>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade div-Shadow "
          id="Tab2"
          role="tabpanel"
          aria-labelledby="pills-profile-tab"
        >
          <div className="d-flex flex-wrap justify-content-between">
            {Transactions &&
              Transactions.map((item, index) => (
                <Transa key={index} info={item} />
              ))}
          </div>
        </div>

        {Key ? (
          <div
            class="tab-pane fade div-Shadow "
            id="Tab3"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div className="d-flex flex-wrap justify-content-between">
              {type == 2 && (
                <div
                  className="w-75 mx-auto pb-5 tabNumOne "
                  style={{ borderBottom: "2px solid #303481" }}
                >
                  {time[2] == 1 || time[2] == 10 || time[2] == 20 ? (
                    ""
                  ) : (
                    <small className="text-right fw-bolder my-4 text-warning fs-6">
                      برداشت فقط در روز های اول ماه به طور کامل و ۱۰ام و ۲۰ام به
                      مقدار ۶۰٪ موجودی میباشد .
                    </small>
                  )}
                  <h4 className="text-right fw-bolder my-4">انتقال به کارت</h4>
                  <div className="d-flex flex-row w-100 justify-content-around flex-wrap">
                    <div className="input-width ">
                      <label className="form-label" htmlFor="cart">
                        شماره کارت مقصد را ارسال کنید
                      </label>
                      <div className=" position-relative mb-5">
                        {bank && (
                          <CreatableSelect
                            placeholder={" انتخاب شماره کارت"}
                            options={bank}
                            value={selectNumber}
                            className="w-50 text-dark user-label mt-2 shadow"
                            onChange={(e) => {
                              setSelectNumber(e);
                            }}
                            input={{ borderRadius: "20px" }}
                            container={{ borderRadius: "20px" }}
                            styles={{ borderRadius: "10px" }}
                            isDisabled={
                              !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                            }
                          />
                        )}
                      </div>
                    </div>

                    <div className="input-width">
                      <label className="form-label" for="cost">
                        مبلغ انتقال را وارد کنید
                      </label>
                      <div className=" position-relative">
                        <input
                          disabled={
                            !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                          }
                          // type="number"
                          dir="ltr"
                          id="cost"
                          value={addCommas(Input2)}
                          className="form-control h-25 inputs rounded-pill shadow "
                          onChange={(e) => {
                            if (time[2] == 1) {
                              if (
                                removeCommas(e.target.value) > current_inventor
                              ) {
                                toast.error("مبلغ، از موجودی شما بیشتر است", {
                                  position: "top-center",
                                });
                                setInput2(removeCommas(Input2));
                              } else {
                                setInput2(removeCommas(e.target.value));
                              }
                            }
                            if (time[2] == 10 || time[2] == 20) {
                              if (
                                removeCommas(e.target.value) >
                                current_inventor * 0.6
                              ) {
                                toast.error(
                                  "شما فقط میتوانید شصت درصد از موجودی خود را برداشت کنید",
                                  {
                                    position: "top-center",
                                  }
                                );
                                setInput2(removeCommas(Input2));
                              } else {
                                setInput2(removeCommas(e.target.value));
                              }
                            }
                          }}
                          style={{ width: "260px" }}
                        />
                        {/* <span
                      className="position-absolute bg-white p-1 lablel"
                      style={{ top: "-20px", fontSize: "15px", right: "10px" }}
                    >
                      مبلغ
                    </span> */}
                      </div>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      disabled={
                        !(time[2] == 1 || time[2] == 10 || time[2] == 20)
                      }
                      type="button"
                      onClick={() => {
                        if (Input2 == "" || selectNumber == "") {
                          toast.error(
                            "شماره کارت مقصد و مبلغ انتفال نمیتوانند خالی باشند",
                            {
                              position: "top-center",
                            }
                          );
                        } else if (Input2 > current_inventor) {
                          toast.error("مبلغ انتفال از موجودی شمابیشتر است", {
                            position: "top-center",
                          });
                        } else if (
                          Input2 != "" &&
                          selectNumber != "" &&
                          Input2 < current_inventor
                        ) {
                          InventoryUpdate();
                          TransferTo(selectNumber.value, Input2);
                        }
                      }}
                      className="btn text-white border-3 border-light mt-3 but-width"
                      style={{
                        backgroundColor: "green",
                        borderRadius: "10px",
                        padding: "5px 60px",
                        borderRadius: "15px",
                      }}
                    >
                      ثبت
                    </button>
                  </div>
                </div>
              )}
              {Transactions2 &&
                Transactions2?.slice(
                  (currentPage - 1) * 10,
                  (currentPage - 1) * 10 + 10
                ).map((item, index) => <Transa key={index} info={item} />)}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {type != "-1" && (
        <div className="d-flex justify-content-center mt-3">
          <Pagination
            total={Transactions2.length}
            pageSize={6}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      )}

      {/* <!--toast notif--> */}
      <ToastContainer />
    </div>
  );
}
